import React from 'react';
import { Button } from 'clad';

class CancelButton extends React.PureComponent {
    render() {
        const { props } = this;
        return <Button {...props} />;
    }
}

export default CancelButton;
